import { render } from "./BWelcomePage.vue?vue&type=template&id=d179ec94&scoped=true"
import script from "./BWelcomePage.vue?vue&type=script&lang=js"
export * from "./BWelcomePage.vue?vue&type=script&lang=js"

import "./BWelcomePage.vue?vue&type=style&index=0&id=d179ec94&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d179ec94"]])

export default __exports__